import { sortBy } from 'lodash'

import PortalApi from '@/services/Api/PortalApi'
import Employee from '@/models/Employee'

const state = () => ({
  onboarders: [],
  onboardersLoaded: false
})

const getters = {
  onboarders (state) {
    return state.onboarders
  },
  onboarderOptions (state) {
    return state.onboarders
      .map(onboarder => ({
        name: onboarder.name,
        value: onboarder.user
      }))
  },
  onboardersLoaded (state) {
    return state.onboardersLoaded
  }
}

const actions = {
  loadOnboarders ({ commit }) {
    return PortalApi.fetchOnboarders()
      .then(({ payload }) => {
        commit('setOnboarders', payload.map(onboarder => new Employee(onboarder)))
        commit('setOnboardersLoaded')
      })
      .catch(() => {})
  }
}

const mutations = {
  setOnboarders (state, onboarders) {
    state.onboarders = sortBy(onboarders, 'name')
  },
  setOnboardersLoaded (state) {
    state.onboardersLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
